/* eslint-disable no-unused-vars */
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  addQuantityUpdate: 'add-quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  modalDialogClose: 'modal-dialog-close',
  toastOpen: 'toast-open',
};
